<template>
  <transition name="fade-in-down">
    <div
      v-if="isVisible"
      class="login-popup align-center"
    >
      <div class="popup-content uppercase bold">
        <p>{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      isVisible: false,
      message: ''
    }
  },
  beforeMount () {
    this.$bus.$on('user-after-logout', ({ silent }) => {
      if (!silent) {
        this.showPopup(this.$t("You're logged out"))
      }
    })

    this.$bus.$on('user-after-login', () => {
      this.showPopup(this.$t('You are logged in!'))
    })
  },
  methods: {
    showPopup (message) {
      this.message = message
      this.isVisible = true
      setTimeout(() => {
        this.isVisible = false
      }, 5000)
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/variables/grid';
@import '~theme/css/variables/components';
@import '~theme/css/helpers/mixins';

$z-index-notification: map-get($z-index, notification);

.login-popup {
  position: fixed;
  top: 100px;
  right: 0;
  z-index: $z-index-notification;
  background-color: white;
  padding: 15px 40px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

  @include mobile {
    width: auto;
    bottom: auto;
    left: 10px;
    right: 10px;
    top: 10px;
    border-radius: 10px;
    padding: 10px 15px;

    .fade-in-down-enter,
    .fade-in-down-leave-to {
      transform: translateY(100%);
    }
  }
}

.popup-content {
  font-size: 18px;
  color: color(primary);

  @include mobile {
    font-size: 16px;
  }
}
</style>
